import { defineMessages } from 'react-intl';

export default defineMessages({
  labelSignInGoogle: {
    id: 'Sign in with Google',
    defaultMessage: 'Sign in with Google'
  },
  labelSignInFacebook: {
    id: 'Sign in with Facebook',
    defaultMessage: 'Sign in with Facebook'
  },
  labelLinkSignUp: {
    id: 'You do not have an account? Sign up',
    defaultMessage: 'You do not have an account? Sign up'
  },
  labelLinkForgotPassword: {
    id: 'Have you forgotten?',
    defaultMessage: 'Have you forgotten?'
  },
  labelLinkRecoverPassword: {
    id: 'Recover password',
    defaultMessage: 'Recover password'
  },
  divider: {
    id: 'OR',
    defaultMessage: 'OR'
  },
  forgotPasswordURL: {
    id: 'forgotPasswordURL',
    defaultMessage: '/account/recover-password'
  },
  signUpUserURL: {
    id: 'signUpUserURL',
    defaultMessage: '#'
  }
});
